import React, {useEffect, useState} from 'react'

const trimOrNull = v => {
  if (!v) return null
  const s = String(v).trim()
  return s.length ? s : null
}

const shortSha = sha => (sha && sha.length >= 7 ? sha.slice(0, 7) : sha)

export const BuildInfo = ({style}) => {
  const [sha, setSha] = useState(trimOrNull(process.env.REACT_APP_BUILD_SHA))
  const [date, setDate] = useState(trimOrNull(process.env.REACT_APP_BUILD_DATE))

  useEffect(() => {
    let cancelled = false

    // Validate response is plain text, not HTML fallback
    const isValidText = (res, txt) => {
      if (!res.ok || !txt) return false
      // Reject HTML responses (dev server fallback returns index.html)
      if (txt.trim().startsWith('<')) return false
      return true
    }

    const load = async () => {
      try {
        const [shaRes, dateRes] = await Promise.all([
          fetch('/buildsha.txt', {cache: 'no-store'}),
          fetch('/builddate.txt', {cache: 'no-store'})
        ])
        const [shaTxt, dateTxt] = await Promise.all([
          shaRes.ok ? shaRes.text() : null,
          dateRes.ok ? dateRes.text() : null
        ])
        if (cancelled) return
        if (isValidText(shaRes, shaTxt)) setSha(trimOrNull(shaTxt))
        if (isValidText(dateRes, dateTxt)) setDate(trimOrNull(dateTxt))
      } catch (e) {
        // Intentionally ignore (dev server / network errors).
      }
    }

    load()
    return () => {
      cancelled = true
    }
  }, [])

  if (!sha && !date) return null

  return (
    <span style={{fontSize: 12, color: 'rgba(0, 0, 0, 0.45)', ...style}}>
      Build: {shortSha(sha) || 'unknown'}
      {date ? ` · ${date}` : null}
    </span>
  )
}
